var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2578 6.97767L20.0003 11.2402V2.53516L13.2578 6.97767Z",
    fill: "#BAB9B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.53516V11.2402L6.74253 6.97767L0 2.53516Z",
    fill: "#BAB9B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7516 0H1.25157C0.627815 0 0.132813 0.465002 0.0390625 1.06375L10.0016 7.62753L19.9641 1.06375C19.8704 0.465002 19.3754 0 18.7516 0Z",
    fill: "#BAB9B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1116 7.73172L10.3429 8.89672C10.2379 8.96547 10.1191 8.99922 9.99911 8.99922C9.87911 8.99922 9.76035 8.96547 9.65535 8.89672L7.8866 7.73047L0.0390625 12.6942C0.135313 13.288 0.627815 13.7492 1.24907 13.7492H18.7491C19.3704 13.7492 19.8629 13.288 19.9592 12.6942L12.1116 7.73172Z",
    fill: "#BAB9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/iconMessage.2177f644cf01f3fb1df897ac77efca3f.svg";
export { ForwardRef as ReactComponent };